import * as actions from './tenants/actions'
import * as mutations from './tenants/mutations'
import * as getters from './tenants/getters'

import { dataProps } from './tenants/properties'

const state = {
    list: [],
    props: JSON.parse(JSON.stringify(dataProps))
}

export default {
    state,
    getters,
    mutations,
    actions
}


// WEBPACK FOOTER //
// ./src/store/modules/tenants.js